module.exports = __webpack_public_path__ + "static/Api-c32586707503a24b9d831b7826a4b0f3.svg";